
























import BaseChips from '../BaseChips/BaseChips.vue';

export default {
    name: 'Chips',
    extends: BaseChips
};
